import styled from 'styled-components';

export const ImagesRow = styled.div`
    display: flex;
    justify-content: center;
`;
